import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetUploadDialogIconButtonCancel: {
    height: '2rem',
    position: 'absolute',
    right: 8,
    top: 8,
    width: '2rem'
  },
  formFieldsContainer: {
    flexWrap: 'wrap',
    marginBottom: 3,
    marginTop: 3,
    gap: theme.spacing(3),
    alignItems: 'flex-start',
    alignContent: 'flex-start'
  }
}));

export default useStyles;
